import { render, staticRenderFns } from "./PageSubheading.vue?vue&type=template&id=593bcb36&scoped=true&"
import script from "./PageSubheading.vue?vue&type=script&lang=js&"
export * from "./PageSubheading.vue?vue&type=script&lang=js&"
import style0 from "./PageSubheading.vue?vue&type=style&index=0&id=593bcb36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593bcb36",
  null
  
)

export default component.exports